import { gql } from '@apollo/client'

export const ADD_MEAL_TO_TRIP = gql`
    mutation addMealToTrip($meal_details: MealToTripInput!) {
        addMealToTrip(meal_details: $meal_details) {
            code
            success
            message
        }
    }
`

export const REMOVE_MEAL_FROM_TRIP = gql`
    mutation removeMealFromTrip($tripMealId: NonEmptyString!) {
        removeMealFromTrip(trip_meal_id: $tripMealId) {
            code
            success
            message
        }
    }
`

export const UPDATE_MEAL_ORDER_STATUS = gql`
    mutation UpdateMealOrderStatus($orderDetails: UpdateMealOrderStatusInput!) {
        updateMealOrderStatus(order_details: $orderDetails) {
            code
            success
            message
        }
    }
`
